import { CAUI, Component, ControlButton, ControlButtonContainer } from 'ca-ui';

export class VRContentView extends Component {
  static defaultOptions = {
    componentName: 'VRContentView'
  };

  constructor (vr, options) {
    super($.extend({}, VRContentView.defaultOptions, options));

    this.vr = vr;
    this.zoommed = false;
    this.isPlayingTts = false;

    this.el.addClass(this.getComponentClass() + '--closed');

    this.shim = $('<div class="' + this.getComponentClass() + '_shim"></div>');
    this.el.append(this.shim);

    this.scrollArea = $(
      '<div class="' + this.getComponentClass() + '_scrollarea"></div>'
    );
    this.el.append(this.scrollArea);

    this.scrollArea.on(
      'click',
      function (e) {
        options.onClose(e);
      }
    );

    this.container = $(
      '<div class="' + this.getComponentClass() + '_container"></div>'
    );
    this.container.on('click', (e) => {
      // e.stopPropagation();
      return false;
    });
    this.scrollArea.append(this.container);

    this.controlsContainer = new ControlButtonContainer({});
    this.add(this.controlsContainer);

    // Close
    this.closeButton = new ControlButton({
      icon: 'times',
      tooltip: 'Return to room',
      tooltipDirection: 'left'
    });
    this.controlsContainer.add(this.closeButton);

    this.closeButton.on(
      'click',
      function (e) {
        options.onClose(e);
      }
    );

    // Zoom
    this.zoomControlGroup = $(
      '<div class="ca-vr_control-group ca-vr_control-group_zoom"></div>'
    );
    this.zoomControlGroup.show();
    this.controlsContainer.add(this.zoomControlGroup);

    this.zoomInControl = new ControlButton({
      icon: 'search-plus',
      tooltip: 'Zoom in'
    });
    this.zoomControlGroup.append(this.zoomInControl.el);

    this.zoomOutControl = new ControlButton({
      icon: 'search-minus',
      tooltip: 'Zoom out'
    });
    this.zoomControlGroup.append(this.zoomOutControl.el);

    this.zoomInControl.on(
      'click touchstart',
      function () {
        this.toggleZoom();
      }.bind(this)
    );

    this.zoomOutControl.on(
      'click touchstart',
      function () {
        this.toggleZoom();
      }.bind(this)
    );

    // Audio
    this.audioButton = new ControlButton({
      icon: 'microphone-alt',
      tooltip: 'Read text',
      tooltipDirection: 'left'
    });
    this.controlsContainer.add(this.audioButton);

    this.audioButton.on(
      'click touchstart',
      function () {
        if (this.isPlayingTts) this.stopTextToSpeech();
        else this.playTextToSpeech(this.content);
      }.bind(this)
    );

    // Fullscreen
    if (this.vr.isFullscreenEnabled()) {
      this.fullscreenButton = new ControlButton({
        icon: 'expand',
        tooltip: 'Fullscreen',
        tooltipDirection: 'left'
      });
      this.controlsContainer.add(this.fullscreenButton);

      this.fullscreenButton.on(
        'click touchstart',
        function () {
          CAUI.enterFullscreen(!this.fullscreen, this.vr.wrapper[0]);
          this.fullscreen = !this.fullscreen;

          this.fullscreenButton.setIcon(
            this.fullscreen ? 'compress' : 'expand'
          );
          this.fullscreenButton.setTooltip(
            this.fullscreen ? 'Exit fullscreen' : 'Fullscreen'
          );
          this.layout();
        }.bind(this)
      );
    }
  }

  toggleZoom () {
    this.zoommed = !this.zoommed;
    this.zoomInControl.el.attr('disabled', this.zoommed);
    this.zoomOutControl.el.attr('disabled', !this.zoommed);
    this.el.toggleClass(this.getComponentClass() + '--zoomed', this.zoommed);
  }

  setContent (content, callback) {
    this.loaded = false;
    this.content = content;
    this.container.empty();

    this.zoommed = true;
    this.toggleZoom();

    if (content) {
      if (content.textToSpeech != null) this.initTextToSpeech();
      this.audioButton.el[0].style.setProperty(
        'display',
        content.textToSpeech != null ? 'flex' : 'none',
        'important'
      );

      if (!content.type) content.type = 'default';
      this.el.addClass(this.getComponentClass() + '_type-' + content.type);
      setTimeout(() => this.setContentSize(content), 2);

      // Wait for animation
      setTimeout(() => {
        if (content.data.metadata) {
          const popupContainer = $(`<a href="javascript;;" data-modal-uuid="${content.data.id}" class="ca-ver_popup"></a>`);
          const popupData = content.data.metadata.children;
          if (popupData[0].props.media !== null) {
            // check type
            if (popupData[0].props.media.type === 'image') {
              const img = $(`<img src="${popupData[0].props.media.url}" />`);
              popupContainer.append(img);
            } else if (popupData[0].props.media.type === 'video') {
              const video = $(`<video width='100%' controls><source src="https://media.caapp.com.au/${popupData[0].props.media.ref}"></video>`);
              popupContainer.append(video);
            }
          }

          if (popupData[1] !== undefined && popupData[1].children) {
            const headingContainer = $('<div class="ca-ver_popup--heading"></div>');
            const heading = $(popupData[1].children[0].value);
            headingContainer.append(heading);
            popupContainer.append(headingContainer);
          }

          if (popupData[2] !== undefined && popupData[2].children) {
            const bodyContainer = $('<div class="ca-ver_popup--body"></div>');
            const body = $(popupData[2].children[0].value);
            bodyContainer.append(body);
            popupContainer.append(bodyContainer);
          }
          this.container.append(popupContainer);
          callback();
          // if there is a heading, load the heading
          // if there is content, load the content
        } else if (content.type === 'image') {
          const img = $('<img src="' + content.image + '" />');
          this.container.append(img);
          img.on('load', () => {
            this.loaded = true;
            this.container.css('overflow', 'auto');
            this.container.css('height', 'auto');

            callback();
          });
        } else if (content.type === 'video') {
          const video = $('<iframe src="' + content.video + '" />');
          this.container.append(video);
          video.on('load', () => {
            this.loaded = true;
            this.container.css('overflow', 'hidden');

            callback();
          });
        } else if (content.type === 'pdf') {
          // marking as loaded because PDFs have their own loading animations
          this.loaded = true;
          const pdfView = $(
            '<div class="pdf-view-wrapper" data-pdf="' +
              content.pdf +
              '"></div>'
          );
          this.container.append(pdfView);
          pdfView.caPDFView({ url: content.pdf });
          pdfView.on('load', () => {
            this.loaded = true;
            this.container.css('overflow', 'hidden');

            callback();
          });
        } else if (content.type === 'iframe') {
          const iframe = $('<iframe src="' + content.src + '" />');
          this.container.append(iframe);
          iframe.on('load', () => {
            this.loaded = true;
            this.container.css('overflow', 'hidden');

            callback();
          });
        } else if (content.type === 'script') {
          const script = $(
            '<script language="JavaScript" type="text/javascript" charset="utf-8" src="' +
              content.src +
              '"></script>'
          );
          this.container.append(script);
          callback();
        } else {
          callback();
        }
      }, 400);
    } else {
      this.el.addClass(this.getComponentClass() + '_type-placeholder');
      setTimeout(() => this.setContentSize(null), 2);
      callback();
    }
  }

  playTextToSpeech (content) {
    this.vr.showLoading('Loading...');

    const text =
      '<speak>' +
      content.textToSpeech.text.join('<break time="400ms"/>') +
      '</speak>';

    $.post('/api/text-to-speech/', { text: text })
      .done(
        function (data) {
          this.isPlayingTts = true;

          this.textToSpeechSource.attr('src', data);
          this.textToSpeechPlayer[0].load();
          this.textToSpeechPlayer[0].play();

          this.audioButton.setIcon('microphone-alt-slash');
          this.audioButton.setTooltip('Stop reading');
        }.bind(this)
      )
      .fail(function (e) {
        console.log('fail');
        console.log(e);
      })
      .always(
        function () {
          this.vr.hideLoading();
        }.bind(this)
      );
  }

  setContentSize (content) {
    this.container.addClass(this.getComponentClass() + '_container--resizing');

    if (content && content.type === 'video') {
      this.container.css('top', '100px');
      this.container.css('left', '50%');
      this.container.css('transform', 'translateX(-50%)');
      this.container.width('calc(100vw - 160px)');
      this.container.height('calc(100% - 200px)');
    } else if (content && content.width && content.height) {
      this.container.width(content.width);
      this.container.height(content.height);

      this.container.css('top', 'calc(50% - ' + content.width / 2 + 'px)');
      this.container.css('left', 'calc(50% - ' + content.height / 2 + 'px)');
    } else {
      this.container.css('top', '100px');
      this.container.css('left', '50%');
      this.container.css('transform', 'translateX(-50%)');
      this.container.css('width', '100%');
      this.container.css('max-width', '1280px');

      if ((this.loaded && content.type === 'image') || content.type === 'pdf') {
        this.container.css('height', 'auto');
      } else this.container.height('auto');
    }
  }

  openFrom (div) {
    this.open();

    const bounds = div[0].getBoundingClientRect();

    console.log('left: ' + bounds.left);
    console.log('top: ' + bounds.top);
    console.log('width: ' + bounds.width + 'px');
    console.log('height: ' + bounds.height + 'px');

    this.container.css('left', bounds.left + 'px');
    this.container.css('top', bounds.top + 'px');
    this.container.width(bounds.width + 'px');
    this.container.height(bounds.height + 'px');
  }

  open () {
    this.container.removeClass(
      this.getComponentClass() + '_container--resizing'
    );
    this.el.removeClass(this.getComponentClass() + '--closed');
    this.scrollArea.show();
    this.shim.show();
  }

  close () {
    this.container.empty();
    this.stopTextToSpeech();
    this.el.removeClass();
    this.el.addClass(this.getComponentClass());
    this.el.addClass(this.getComponentClass() + '--closed');
    this.scrollArea.hide();
    this.shim.hide();
  }

  stopTextToSpeech () {
    if (this.textToSpeechPlayer) this.textToSpeechPlayer[0].pause();
    this.isPlayingTts = false;
    this.audioButton.setIcon('microphone-alt');
    this.audioButton.setTooltip('Read text');
  }

  initTextToSpeech () {
    if (this.textToSpeechEnabled) return;
    this.textToSpeechEnabled = true;

    this.textToSpeechPlayer = $(
      '<audio class="ca-vr_texttospeech" controls="controls"></audio>'
    );
    this.el.append(this.textToSpeechPlayer);

    this.textToSpeechPlayer.on(
      'ended',
      function () {
        this.isPlayingTts = false;
        this.audioButton.setIcon('microphone-alt');
        this.audioButton.setTooltip('Read text');
      }.bind(this)
    );

    this.textToSpeechPlayer.on(
      'pause',
      function () {
        this.isPlayingTts = false;
        this.audioButton.setIcon('microphone-alt');
        this.audioButton.setTooltip('Read text');
      }.bind(this)
    );

    this.textToSpeechSource = $('<source type="audio/mpeg" />');
    this.textToSpeechPlayer.append(this.textToSpeechSource);
  }
}
